import React, { Fragment, useCallback } from 'react';
import { useLocation } from "@remix-run/react";
import { useSearchState } from '../../../pages/Search/SearchContext';
import { NavigationTabBar } from '../../NavigationTabBar/NavigationTabBar';
import { horizontalPadding } from '../../NavigationTabBar/NavigationTabLink.styles';
import { containerPadding } from '../../PlayContainer/PlayContainer';
import { useHeaderState } from '../HeaderContext';
import { NavigationContainer, Title, TitleContainer } from './SecondLevelNavigation.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SecondLevelNavigation = () => {
  const {
    config: {
      secondLevelNavigation
    },
    route
  } = useHeaderState();
  const {
    searchOpen
  } = useSearchState();
  const location = useLocation();
  const isActive = useCallback(link => {
    const urlParams = new URLSearchParams(location.search);
    return !!(link.isActive && link.isActive(route, urlParams));
  }, [location, route]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: secondLevelNavigation && !searchOpen && /*#__PURE__*/_jsxs(Fragment, {
      children: [secondLevelNavigation.title && /*#__PURE__*/_jsx(TitleContainer, {
        children: /*#__PURE__*/_jsx(Title, {
          children: secondLevelNavigation.title
        })
      }), /*#__PURE__*/_jsx(NavigationContainer, {
        sidePadding: {
          mediaQuery: [['medium', containerPadding.medium - horizontalPadding], ['largeUp', containerPadding.large - horizontalPadding]],
          default: containerPadding.small - horizontalPadding
        },
        children: /*#__PURE__*/_jsx(NavigationTabBar, {
          links: secondLevelNavigation.links.map(link => ({
            title: link.title,
            path: link.path,
            isActive: isActive(link)
          }))
        })
      })]
    })
  });
};